import React, {createContext, useContext, useState} from 'react';

const ModalContext = createContext();

export const ModalProvider = ({ children }) => {
    const [modals, setModals] = useState([]);

    const openModal = (modalContent) => {
        setModals([...modals, modalContent]);
    };

    const closeModal = () => {
        setModals(modals.slice(0, modals.length - 1));
    };

    return (
        <ModalContext.Provider value={{ modals, openModal, closeModal }}>
            {children}
        </ModalContext.Provider>
    );
};

export const useSheetModal = () => useContext(ModalContext);
